import gql from 'graphql-tag';

export const GET_ALL_SUBMISSIONS = gql`
  query GetAllSubmissions(
    $filter: String
    $id: String
    $userFacilities: [String]
  ) {
    GetLoggedInUser(Id: $id) {
      FirstName
      LastName
      FacilityAssignments {
        Facility {
          Id
          Name
          KeyChain {
            LegacyId
            OracleId
            SalesforceId
          }
        }
      }
    }
    GetAllEnergyCreditSubmissions(
      filter: $filter
      userFacilities: $userFacilities
    ) {
      Items {
        Id
        OrderNumber
        SerialNumber
        FacilityNumber
        CustomerName
        RetailerName
        CertificateMailed
        FurnaceType
        HomeCity
        HomeState
        HomePostalCode
        HeatPumpInvoiceAvailable
        Status
        Version
        SoldDate
        SubmissionCreateDate
      }
      HasNextPage
      HasPreviousPage
      PageNumber
      PageSize
      TotalCount
      TotalPages
      SortDirection
    }
  }
`;

export const GET_SUBMISSION = gql`
  query GetSubmission($id: ID!) {
    GetEnergyCreditSubmission(Id: $id) {
      Id
      FormStructureId
      SubmissionValues {
        Id
        PropertyBindingKey
        Value
      }
      SubmittedOn
      ModifiedOn
    }
  }
`;

export const GET_HOMECENTER = gql`
  query GetHomeCenter($id: String!) {
    GetHomeCenterByLegacyId(Id: $id) {
      AreaCode
      City
      Id
      HomeCenterType
      IsActive
      Name
      KeyChain {
        LegacyId
      }
    }
  }
`;

export const UPDATE_FACILITY_ASSIGNMENT = gql`
  mutation updateFacilities($id: ID!, $payload: String!) {
    UpdateFacilityAssignments(Id: $id, Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const UPDATE_SUBMISSION = gql`
  mutation updateSubmission($id: ID!, $payload: String!) {
    UpdateEnergyCreditSubmission(Id: $id, Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const GET_MANUAL_SUBMISSION_INFO = gql`
  query getManualSubmissionInfo(
    $serialNumber: String!
    $userFacilities: [String]
    $userEmail: String!
  ) {
    GetManualSubmissionInfo(
      UserEmail: $userEmail
      Payload: $serialNumber
      userFacilities: $userFacilities
    ) {
      LongSerialNumber
      Status
      SubmissionId
      ErrorMessage
    }
  }
`;

export const GET_HEAT_PUMP_INVOICE = gql`
  query getHeatPumpInvoice($payload: String!) {
    GetHeatPumpInvoice(Payload: $payload)
  }
`;

export const DELETE_SUBMISSION = gql`
  mutation deleteSubmission($id: ID!) {
    DeleteEnergyCreditSubmission(Id: $id) {
      Success
      Message
      UpdatedData
    }
  }
`;
